// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/entity/v2/portfolio.proto (package securities.trm.core.portfolio.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PriceAlgorithm } from "../../../smart_order/trailing_stop/order/entity/v1/price_algorithm_pb.js";
import { Money } from "../../../../../../google/type/money_pb.js";
import { Date } from "../../../../../../google/type/date_pb.js";

/**
 * Side defines sides for an order
 *
 * @generated from enum securities.trm.core.portfolio.entity.v2.Side
 */
export const Side = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Side",
  [
    {no: 0, name: "SIDE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIDE_BUY", localName: "BUY"},
    {no: 2, name: "SIDE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.PlatformOrderType
 */
export const PlatformOrderType = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.PlatformOrderType",
  [
    {no: 0, name: "PLATFORM_ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLATFORM_ORDER_TYPE_LIMIT_DAY", localName: "LIMIT_DAY"},
    {no: 2, name: "PLATFORM_ORDER_TYPE_MARKET_FAK", localName: "MARKET_FAK"},
    {no: 3, name: "PLATFORM_ORDER_TYPE_FAST_ORDER", localName: "FAST_ORDER"},
  ],
);

/**
 * this number same like AutoOrderLabel
 *
 * @generated from enum securities.trm.core.portfolio.entity.v2.SmartOrderLabelType
 */
export const SmartOrderLabelType = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.SmartOrderLabelType",
  [
    {no: 0, name: "SMART_ORDER_LABEL_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SMART_ORDER_LABEL_TYPE_AUTO_BUY", localName: "AUTO_BUY"},
    {no: 2, name: "SMART_ORDER_LABEL_TYPE_STOP_LOSS", localName: "STOP_LOSS"},
    {no: 3, name: "SMART_ORDER_LABEL_TYPE_TAKE_PROFIT", localName: "TAKE_PROFIT"},
    {no: 5, name: "SMART_ORDER_LABEL_TYPE_TRAILING_STOP", localName: "TRAILING_STOP"},
    {no: 6, name: "SMART_ORDER_LABEL_TYPE_LIMIT_IF_TOUCHED", localName: "LIMIT_IF_TOUCHED"},
    {no: 7, name: "SMART_ORDER_LABEL_TYPE_BRACKET_ORDER", localName: "BRACKET_ORDER"},
    {no: 8, name: "SMART_ORDER_LABEL_TYPE_VOLUME_TRIGGER_ORDER", localName: "VOLUME_TRIGGER_ORDER"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.ActionTarget
 */
export const ActionTarget = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.ActionTarget",
  [
    {no: 0, name: "ACTION_TARGET_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_TARGET_REGULAR", localName: "REGULAR"},
    {no: 2, name: "ACTION_TARGET_DAY_TRADE", localName: "DAY_TRADE"},
    {no: 3, name: "ACTION_TARGET_LEGACY_SMARTORDER", localName: "LEGACY_SMARTORDER"},
    {no: 4, name: "ACTION_TARGET_TRAILING_STOP", localName: "TRAILING_STOP"},
    {no: 5, name: "ACTION_TARGET_STOP_ORDER", localName: "STOP_ORDER"},
    {no: 6, name: "ACTION_TARGET_BRACKET_ORDER", localName: "BRACKET_ORDER"},
    {no: 7, name: "ACTION_TARGET_VOLUME_TRIGGER_ORDER", localName: "VOLUME_TRIGGER_ORDER"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderType
 */
export const OrderType = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_LIMIT", localName: "LIMIT"},
    {no: 2, name: "ORDER_TYPE_MARKET", localName: "MARKET"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.LeverageType
 */
export const LeverageType = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.LeverageType",
  [
    {no: 0, name: "LEVERAGE_TYPE_TRADING_UNSPECIFIED", localName: "TRADING_UNSPECIFIED"},
    {no: 1, name: "LEVERAGE_TYPE_TRADING_BALANCE", localName: "TRADING_BALANCE"},
    {no: 2, name: "LEVERAGE_TYPE_TRADING_LIMIT", localName: "TRADING_LIMIT"},
    {no: 3, name: "LEVERAGE_TYPE_BASIC_LIMIT", localName: "BASIC_LIMIT"},
    {no: 4, name: "LEVERAGE_TYPE_TEMP_LIMIT", localName: "TEMP_LIMIT"},
    {no: 5, name: "LEVERAGE_TYPE_DAY_TRADE", localName: "DAY_TRADE"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.SecuritiesKind
 */
export const SecuritiesKind = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.SecuritiesKind",
  [
    {no: 0, name: "SECURITIES_KIND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SECURITIES_KIND_STOCK", localName: "STOCK"},
    {no: 2, name: "SECURITIES_KIND_BOND", localName: "BOND"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderBookSide
 */
export const OrderBookSide = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderBookSide",
  [
    {no: 0, name: "ORDER_BOOK_SIDE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_BOOK_SIDE_BID", localName: "BID"},
    {no: 2, name: "ORDER_BOOK_SIDE_ASK", localName: "ASK"},
  ],
);

/**
 * PortfolioListSummary contains summary of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary
 */
export const PortfolioSummary = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary",
  () => [
    { no: 1, name: "trading", kind: "message", T: PortfolioSummary_Trading },
    { no: 2, name: "amount", kind: "message", T: PortfolioSummary_Amount },
    { no: 3, name: "profit_loss", kind: "message", T: PortfolioSummary_ProfitLoss },
    { no: 4, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "equity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "debt", kind: "message", T: PortfolioSummary_Debt },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading
 */
export const PortfolioSummary_Trading = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading",
  () => [
    { no: 1, name: "balance", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Trading"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount
 */
export const PortfolioSummary_Amount = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "allocated", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "credit_limit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss
 */
export const PortfolioSummary_ProfitLoss = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss",
  () => [
    { no: 1, name: "net", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "unrealised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "realised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_ProfitLoss"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt
 */
export const PortfolioSummary_Debt = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt",
  () => [
    { no: 1, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Debt"},
);

/**
 * PortfolioPrice contains price information in portfolio for one symbol
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice
 */
export const PortfolioPrice = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice",
  () => [
    { no: 1, name: "latest", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: PortfolioPrice_Average },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average
 */
export const PortfolioPrice_Average = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioPrice_Average"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty
 */
export const PortfolioQty = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty",
  () => [
    { no: 1, name: "stock_on_hand", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "available", kind: "message", T: PortfolioQty_Qty },
    { no: 3, name: "balance", kind: "message", T: PortfolioQty_Qty },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty
 */
export const PortfolioQty_Qty = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty",
  () => [
    { no: 1, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "share", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioQty_Qty"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset
 */
export const PortfolioAsset = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset",
  () => [
    { no: 1, name: "unrealised", kind: "message", T: PortfolioAsset_Unrealised },
    { no: 2, name: "amount_invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised
 */
export const PortfolioAsset_Unrealised = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised",
  () => [
    { no: 1, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "profit_loss", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioAsset_Unrealised"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioFlags
 */
export const PortfolioFlags = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioFlags",
  () => [
    { no: 1, name: "allow_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "have_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "can_buy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "can_sell", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Order defines information on a single order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order
 */
export const Order = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: Order_Time },
    { no: 8, name: "qty", kind: "message", T: Order_Qty },
    { no: 9, name: "price", kind: "message", T: Order_Price },
    { no: 10, name: "amount", kind: "message", T: Order_Amount },
    { no: 11, name: "action", kind: "message", T: Order_Action },
    { no: 12, name: "smart_order", kind: "message", T: Order_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: Order_GTC },
    { no: 14, name: "day_trade", kind: "message", T: Order_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: proto3.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "securities_kind", kind: "enum", T: proto3.getEnumType(SecuritiesKind) },
    { no: 18, name: "platform_order_type", kind: "enum", T: proto3.getEnumType(PlatformOrderType) },
    { no: 19, name: "time_utc", kind: "message", T: Order_TimeUTC },
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell
 */
export const Order_DayTradeForceSell = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount
 */
export const Order_Amount = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: Order_Amount_Fee },
  ],
  {localName: "Order_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee
 */
export const Order_Amount_Fee = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: Order_Amount_Fee_Matched },
  ],
  {localName: "Order_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched
 */
export const Order_Amount_Fee_Matched = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price
 */
export const Order_Price = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: Order_Price_Average },
  ],
  {localName: "Order_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price.Average
 */
export const Order_Price_Average = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Time
 */
export const Order_Time = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Time",
  () => [
    { no: 1, name: "order", kind: "message", T: Timestamp },
    { no: 2, name: "open", kind: "message", T: Timestamp },
    { no: 3, name: "match", kind: "message", T: Timestamp },
  ],
  {localName: "Order_Time"},
);

/**
 * TimeUTC contains time-related information for order in UTC timezone
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.TimeUTC
 */
export const Order_TimeUTC = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.TimeUTC",
  () => [
    { no: 1, name: "order", kind: "message", T: Timestamp },
    { no: 2, name: "open", kind: "message", T: Timestamp },
    { no: 3, name: "match", kind: "message", T: Timestamp },
    { no: 4, name: "gtc_expired", kind: "message", T: Timestamp },
  ],
  {localName: "Order_TimeUTC"},
);

/**
 * Action defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Action
 */
export const Order_Action = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "amend_target", kind: "enum", T: proto3.getEnumType(ActionTarget) },
    { no: 4, name: "cancel_target", kind: "enum", T: proto3.getEnumType(ActionTarget) },
  ],
  {localName: "Order_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder
 */
export const Order_SmartOrder = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "trailing_stop", kind: "message", T: Order_SmartOrder_TrailingStop },
    { no: 6, name: "bracket_order_children", kind: "message", T: BracketOrderChild, repeated: true },
    { no: 7, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "order_type", kind: "enum", T: proto3.getEnumType(OrderType) },
  ],
  {localName: "Order_SmartOrder"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder.TrailingStop
 */
export const Order_SmartOrder_TrailingStop = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder.TrailingStop",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "price_algorithm", kind: "message", T: PriceAlgorithm },
    { no: 3, name: "stop_price", kind: "message", T: Money },
  ],
  {localName: "Order_SmartOrder_TrailingStop"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.GTC
 */
export const Order_GTC = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(Order_GTC_GTCStatus) },
  ],
  {localName: "Order_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus
 */
export const Order_GTC_GTCStatus = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Qty
 */
export const Order_Qty = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.DayTrade
 */
export const Order_DayTrade = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: proto3.getEnumType(Order_DayTradeForceSell) },
  ],
  {localName: "Order_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail
 */
export const OrderDetail = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: OrderDetail_Time },
    { no: 8, name: "qty", kind: "message", T: OrderDetail_Qty },
    { no: 9, name: "price", kind: "message", T: OrderDetail_Price },
    { no: 10, name: "amount", kind: "message", T: OrderDetail_Amount },
    { no: 11, name: "action", kind: "message", T: OrderDetail_Action },
    { no: 12, name: "smart_order", kind: "message", T: OrderDetail_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: OrderDetail_GTC },
    { no: 14, name: "day_trade", kind: "message", T: OrderDetail_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: proto3.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "platform_order_type", kind: "enum", T: proto3.getEnumType(PlatformOrderType) },
    { no: 18, name: "time_utc", kind: "message", T: OrderDetail_TimeUTC },
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell
 */
export const OrderDetail_DayTradeForceSell = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount
 */
export const OrderDetail_Amount = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: OrderDetail_Amount_Fee },
  ],
  {localName: "OrderDetail_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee
 */
export const OrderDetail_Amount_Fee = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: OrderDetail_Amount_Fee_Matched },
  ],
  {localName: "OrderDetail_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched
 */
export const OrderDetail_Amount_Fee_Matched = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price
 */
export const OrderDetail_Price = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: OrderDetail_Price_Average },
  ],
  {localName: "OrderDetail_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average
 */
export const OrderDetail_Price_Average = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "portfolio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Time
 */
export const OrderDetail_Time = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Time",
  () => [
    { no: 1, name: "ordered_at", kind: "message", T: Timestamp },
    { no: 2, name: "opened_at", kind: "message", T: Timestamp },
    { no: 3, name: "matched_at", kind: "message", T: Timestamp },
  ],
  {localName: "OrderDetail_Time"},
);

/**
 * TimeUTC contains time-related information for order in UTC timezone
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.TimeUTC
 */
export const OrderDetail_TimeUTC = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.TimeUTC",
  () => [
    { no: 1, name: "ordered_at", kind: "message", T: Timestamp },
    { no: 2, name: "opened_at", kind: "message", T: Timestamp },
    { no: 3, name: "matched_at", kind: "message", T: Timestamp },
    { no: 4, name: "gtc_expired_at", kind: "message", T: Timestamp },
  ],
  {localName: "OrderDetail_TimeUTC"},
);

/**
 * Action defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Action
 */
export const OrderDetail_Action = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "amend_target", kind: "enum", T: proto3.getEnumType(ActionTarget) },
    { no: 4, name: "cancel_target", kind: "enum", T: proto3.getEnumType(ActionTarget) },
  ],
  {localName: "OrderDetail_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder
 */
export const OrderDetail_SmartOrder = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "enum", T: proto3.getEnumType(OrderDetail_SmartOrder_ConfigPriceType) },
    { no: 5, name: "trailing_stop", kind: "message", T: OrderDetail_SmartOrder_TrailingStop },
    { no: 6, name: "bracket_order_children", kind: "message", T: BracketOrderChild, repeated: true },
    { no: 7, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "order_type", kind: "enum", T: proto3.getEnumType(OrderType) },
    { no: 10, name: "volume_trigger_order", kind: "message", T: OrderDetail_SmartOrder_VolumeTriggerOrder },
  ],
  {localName: "OrderDetail_SmartOrder"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType
 */
export const OrderDetail_SmartOrder_ConfigPriceType = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType",
  [
    {no: 0, name: "CONFIG_PRICE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONFIG_PRICE_TYPE_ABOVE", localName: "ABOVE"},
    {no: 2, name: "CONFIG_PRICE_TYPE_BELOW", localName: "BELOW"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.TrailingStop
 */
export const OrderDetail_SmartOrder_TrailingStop = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.TrailingStop",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "price_algorithm", kind: "message", T: PriceAlgorithm },
    { no: 3, name: "stop_price", kind: "message", T: Money },
  ],
  {localName: "OrderDetail_SmartOrder_TrailingStop"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.VolumeTriggerOrder
 */
export const OrderDetail_SmartOrder_VolumeTriggerOrder = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.VolumeTriggerOrder",
  () => [
    { no: 1, name: "trigger_volume", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "evaluation_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "evaluation_order_book_side", kind: "enum", T: proto3.getEnumType(OrderBookSide) },
  ],
  {localName: "OrderDetail_SmartOrder_VolumeTriggerOrder"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.GTC
 */
export const OrderDetail_GTC = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(OrderDetail_GTC_GTCStatus) },
  ],
  {localName: "OrderDetail_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus
 */
export const OrderDetail_GTC_GTCStatus = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Qty
 */
export const OrderDetail_Qty = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade
 */
export const OrderDetail_DayTrade = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: proto3.getEnumType(OrderDetail_DayTradeForceSell) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "OrderDetail_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild
 */
export const BracketOrderChild = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 4, name: "price", kind: "message", T: BracketOrderChild_PriceChild },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "gtc", kind: "message", T: BracketOrderChild_GTC },
    { no: 7, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "label", kind: "enum", T: proto3.getEnumType(SmartOrderLabelType) },
    { no: 10, name: "profit_loss", kind: "message", T: BracketOrderChild_ProfitLoss },
    { no: 11, name: "action", kind: "message", T: BracketOrderChild_Action },
    { no: 12, name: "lot_ordered", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "amount_ordered", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "amount_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "platform_order_type", kind: "enum", T: proto3.getEnumType(PlatformOrderType) },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild.PriceChild
 */
export const BracketOrderChild_PriceChild = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.PriceChild",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "price_difference_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "trigger", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "BracketOrderChild_PriceChild"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild.GTC
 */
export const BracketOrderChild_GTC = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(BracketOrderChild_GTC_GTCStatus) },
  ],
  {localName: "BracketOrderChild_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.BracketOrderChild.GTC.GTCStatus
 */
export const BracketOrderChild_GTC_GTCStatus = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild.ProfitLoss
 */
export const BracketOrderChild_ProfitLoss = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.ProfitLoss",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "BracketOrderChild_ProfitLoss"},
);

/**
 * Action defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild.Action
 */
export const BracketOrderChild_Action = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.Action",
  () => [
    { no: 1, name: "amend_target", kind: "enum", T: proto3.getEnumType(ActionTarget) },
    { no: 2, name: "cancel_target", kind: "enum", T: proto3.getEnumType(ActionTarget) },
  ],
  {localName: "BracketOrderChild_Action"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Company
 */
export const Company = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Company",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData
 */
export const ExerciseData = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "date", kind: "message", T: ExerciseData_Date },
    { no: 9, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData.Date
 */
export const ExerciseData_Date = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData.Date",
  () => [
    { no: 1, name: "listing", kind: "message", T: Date },
    { no: 2, name: "expired", kind: "message", T: Date },
    { no: 3, name: "mature", kind: "message", T: Date },
    { no: 4, name: "start", kind: "message", T: Date },
    { no: 5, name: "end", kind: "message", T: Date },
  ],
  {localName: "ExerciseData_Date"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Haircut
 */
export const Haircut = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Haircut",
  () => [
    { no: 1, name: "trading_limit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "margin_trading", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioItem
 */
export const PortfolioItem = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioItem",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "haircut", kind: "message", T: Haircut },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail
 */
export const PortfolioDetail = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "bond", kind: "message", T: PortfolioDetail_Bond },
    { no: 9, name: "can_create_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond
 */
export const PortfolioDetail_Bond = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond",
  () => [
    { no: 1, name: "coupon", kind: "message", T: PortfolioDetail_Bond_Coupon },
    { no: 2, name: "maturity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon
 */
export const PortfolioDetail_Bond_Coupon = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon",
  () => [
    { no: 1, name: "year_rate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "distribution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond_Coupon"},
);

/**
 * PortfolioList defines data on response PortfolioListResponse
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList
 */
export const PortfolioList = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList",
  () => [
    { no: 1, name: "smart_order_info", kind: "message", T: PortfolioList_SmartOrderInfo },
    { no: 2, name: "summary", kind: "message", T: PortfolioSummary },
    { no: 3, name: "results", kind: "message", T: PortfolioItem, repeated: true },
    { no: 4, name: "day_trade", kind: "message", T: PortfolioItem, repeated: true },
  ],
);

/**
 * PortfolioListInfo contains info of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo
 */
export const PortfolioList_SmartOrderInfo = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo",
  () => [
    { no: 1, name: "can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "day_trade_can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "PortfolioList_SmartOrderInfo"},
);

